<template>
  <div :class="['ar-card-container', layout]">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CardContainer',
  props: {
    layout: {
      type: String,
      default: 'regular',
      validator: (item) => {
        return ['regular', 'soft'].indexOf(item) > -1
      },
    },
  },
}
</script>

<style scoped>
.ar-card-container {
  background-color: var(--surface-light);
  border: 1px solid #DCDEE4;
  border-radius: 4px;
}
.ar-card-container.soft {
  border-color: #edf1f5;
  overflow: hidden;
}
</style>
